module.exports = __webpack_public_path__ + "img/icon-indices-big.414ebb87.svg";